
import { Link } from 'react-router-dom'

import React, { useState } from "react";
import Button from "./Button";
import BrandName from "./BrandName";
import { GiHamburgerMenu } from "react-icons/gi";
import { MdClose } from "react-icons/md";
import { motion } from "framer-motion";
import "./Navbar.scss";
import { navbarAnimation } from "./Animations";



export default function Home() {
    
    const [toggleNavbar, setToggleNavbar] = useState(false);
    const navbarToggler = () => {
      setToggleNavbar(!toggleNavbar);
    };

    return (
        <motion.div
        className={`navbar ${toggleNavbar === true ? "active" : ""}`}
        variants={navbarAnimation}
        transition={{ delay: 0.1 }}
      >
          
       <div className="col">
          <BrandName />
          <div className="collapseble-button">
            {!toggleNavbar ? (
              <GiHamburgerMenu onClick={navbarToggler} />
            ) : (
              <MdClose onClick={navbarToggler} />
            )}
          </div>
        </div>
  
  
        <nav>
          <div className="links">
            <ul>
              <li>
                 <Link to='/counter'>Workout</Link>
              </li>
              <li>
              <Link to='/start'>Practice Yoga</Link>
              </li>
  
              <li>
               <Link to='/tutorials'>Posture Monitor</Link>
              </li>
            
              <li>
                <Button content="Signup" />
              </li>
            </ul>
          </div>
        </nav>
   </motion.div>
    
    )
}


{/*

*/}